import { Component, Inject } from '@angular/core';
import { Lists, MAX_LIST_RAW_DATA } from '../../services/lists.service';
import { CreateContactListComponent } from '../../../results/lists/components/create-contact-list/create-contact-list.component';
import { CreateCompanyListComponent } from '../../../results/lists/components/create-company-list/create-company-list.component';
import { ToastrService } from 'ngx-toastr';
import {  MAT_DIALOG_DATA,  MatDialog,  MatDialogConfig,  MatDialogRef } from '@angular/material/dialog';
import { LEGACY_THEME_CLASS } from 'src/app/shared/constants';

@Component({
    selector: 'app-data-enrichment',
    templateUrl: './data-enrichment.component.html',
    styleUrls: ['./data-enrichment.component.scss'],
    standalone: false
})

export class DataEnrichmentComponent {
    file;
    type;
    constructor(
        private readonly listsService: Lists,
        private readonly toastr: ToastrService,
        private readonly matDialog: MatDialog,
        private readonly matDialogRef: MatDialogRef<DataEnrichmentComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data: any,
    ) {
        if (this.data['files']) {
            this.file = this.data['files'];
        }
    }

    openList(type) {
        this.type = type;
    }
    next() {
        this.close();
        this.openContactList(this.type);
    }
    openContactList(type) {
        const config: MatDialogConfig = {
            panelClass: ['modal-xl', 'modal-dialog--max-height', LEGACY_THEME_CLASS],
            data: {
                files: this.file,
            }
        };
        if (type === 'contact') {
            this.matDialog.open(CreateContactListComponent, config);
        } else {
            this.matDialog.open(CreateCompanyListComponent, config);
        }
    }
    close() {
        this.matDialogRef.close();
    }
}
